export const SafeNotificationsOption = {
	DISABLED: 'DISABLED',
	ENABLED: 'ENABLED',
};

export type SafeNotificationsSetting = {
	safeNotificationSetting: (typeof SafeNotificationsOption)[keyof typeof SafeNotificationsOption];
};
